define(
    'modules/split-button',['jquery'],

    function ($) {
        /**
         * @class SplitButton
         * @param el
         * @constructor
         */
        function SplitButton (el) {
            var self = this;

            this.el = el;
            this.opener = el.find('.split-button__dropdown');

            this.el.on('collapse', function () {
                self.collapse();
            });
        }

        /**
         * @method expand
         */
        SplitButton.prototype.expand = function () {
            var overflow = this.opener.next(),
                self = this;

            overflow.height(overflow[0].scrollHeight);
            overflow.attr('data-expanded', '');
            overflow.parent().addClass('split-button--expanded');

            // Reverse dropdown if it touches the bottom of the screen
            if ( ( $(overflow).offset().top + overflow[0].scrollHeight ) > ( $(window).height() + $(window).scrollTop() ) ) {
                overflow.addClass('reversed');
            } else {
                overflow.removeClass('reversed');
            }

            $(document).on('click.splitButtonOutsideClick', function (event) {
                self.collapse();
            });
        };

        /**
         * @method collapse
         */
        SplitButton.prototype.collapse = function () {
            var overflow = this.opener.next();

            overflow.height(0);
            overflow.removeAttr('data-expanded');
            overflow.parent().removeClass('split-button--expanded');

            $(document).off('click.splitButtonOutsideClick');
        };

        /**
         * @method toggle
         */
        SplitButton.prototype.toggle = function () {
            var overflow = this.opener.next();

            if (!overflow.is('[data-expanded]')) {
                this.expand();
            } else {
                this.collapse();
            }
        };

        // Setup bindings
        $('body').on('click', '.split-button__dropdown', function (event) {
            event.preventDefault();
            event.stopPropagation();

            new SplitButton($(this).parent())
                .toggle();
        });
    }
);
